import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Ya no hay token en localStorage que revisar -- la única forma de saber
  // si hay sesión es preguntarle al backend, que la reconoce por la cookie
  // httpOnly (el navegador la manda solo, este código ni la ve).
  const loadCurrentUser = useCallback(async () => {
    try {
      const { data } = await api.get("/api/auth/me");
      setUser(data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadCurrentUser();
  }, [loadCurrentUser]);

  const login = async (email, password) => {
    const { data } = await api.post("/api/auth/login", { email, password });
    setUser(data.user);
    return data.user;
  };

  const register = async ({ email, password, fullName, phone }) => {
    await api.post("/api/auth/register", {
      email,
      password,
      full_name: fullName,
      phone: phone || null,
    });
  };

  const logout = async () => {
    try {
      await api.post("/api/auth/logout");
    } finally {
      // Se limpia el estado local pase lo que pase con la llamada -- si el
      // backend no respondió, igual no tiene sentido seguir mostrando al
      // usuario como logueado en esta pestaña.
      setUser(null);
    }
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth debe usarse dentro de <AuthProvider>");
  return ctx;
};

export default AuthContext;
